<script>
export default {
  name: "CrmPointsCard",
  props: {
    profile: {
      type: Object,
      default: () => ({})
    },
    dataTest: {
      type: String,
      default: undefined
    }
  },
  computed: {
    memberLevel() {
      return Array.isArray(this.profile.member_list)
        ? this.profile.member_list[0] || {}
        : {};
    },
    hasMemberCardImage() {
      return Boolean(this.memberLevel.card_layout_front);
    },
    cardStyle() {
      if (this.hasMemberCardImage) {
        return {
          backgroundImage: `url("${encodeURI(
            this.memberLevel.card_layout_front
          )}")`,
          color: this.memberLevel.font_color || "#fff"
        };
      }

      return {
        background: "var(--primary-color)",
        color: "var(--font-primary-color)"
      };
    },
    totalPoint() {
      return this.numeralFormat(this.profile.total_point || 0);
    },
    expiringPoint() {
      return this.numeralFormat(this.profile.point_expired || 0);
    },
    expiredDate() {
      if (!this.profile.point_expired_date) return "-";
      return this.$moment(this.profile.point_expired_date).format("DD/MM/YYYY");
    },
    tierName() {
      return (
        this.memberLevel.name ||
        this.memberLevel.member_level_language?.[0]?.display ||
        this.profile.member_level_name ||
        this.profile.tier_name ||
        this.$t("member_tier")
      );
    },
    showqr() {
      this.$router.push("/manage");
    }
  }
};
</script>

<template>
  <section
    :class="[
      'crm-points-card',
      { 'crm-points-card--image': hasMemberCardImage }
    ]"
    :style="cardStyle"
    :data-test="dataTest"
  >
    <div class="crm-points-card__main">
      <div>
        <div class="crm-points-card__point">
          {{ totalPoint }} <span>{{ $t("currency_unit") }}</span>
        </div>
        <div class="crm-points-card__caption">
          {{ $t("current_total_spend") }}
        </div>
      </div>
      <div class="crm-points-card__tier">
        {{ tierName }}
      </div>
    </div>
    <div class="crm-points-card__bottom">
      <span class="crm-points-card__pill"
        >{{ expiringPoint }} {{ $t("currency_unit") }}
      </span>
      <span>{{ $t("point_expired") }} {{ expiredDate }}</span>
      <font-awesome-icon
        :icon="['fas', 'qrcode']"
        class="crm-points-card__qr"
        @click="showqr()"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.crm-points-card {
  position: relative;
  min-height: 150px;
  overflow: hidden;
  padding: 17px 16px;
  border-radius: 12px;
  background-position: center;
  background-size: cover;
  box-shadow: 0 4px 12px rgba(180, 0, 42, 0.28);
  background-color: var(--primary-color);
  display: flex;
  flex-direction: column;
  color: white;
}

.crm-points-card::after {
  content: "";
  position: absolute;
  right: -42px;
  bottom: -52px;
  width: 160px;
  height: 160px;
  border: 26px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.crm-points-card--image::after {
  display: none;
}

.crm-points-card__main {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.crm-points-card__point {
  font-size: var(--text-4xl);
  font-weight: 800;
  line-height: 1;
}

.crm-points-card__point span {
  font-size: var(--text-lg);
}

.crm-points-card__caption,
.crm-points-card__bottom {
  font-size: var(--text-md);
  opacity: 0.88;
}

.crm-points-card__tier {
  min-width: 112px;
  padding: 12px 10px;
  // background: rgba(255, 255, 255, 0.92);
  text-align: right;
  font-size: var(--text-lg);
  font-weight: 600;
}

.crm-points-card__bottom {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  // margin-top: 22px;
  margin-top: auto;
}

.crm-points-card__pill {
  padding: 4px 9px;
  border-radius: 999px;
  background: #fff;
  color: var(--primary-color);
  font-weight: 800;
}

.crm-points-card__qr {
  margin-left: auto;
  font-size: var(--text-4xl);
}
</style>
